import InvoicesUnifiedTable from "@/components/Organisms/InvoicesUnifiedTable";
import { INVOICE_TYPE } from "../invoices";

/**
 * OpenInvoicesTable Component
 *
 * Wrapper component that displays open invoices using the unified invoices table.
 * This is a lightweight wrapper around InvoicesUnifiedTable with variant='open'.
 */
const OpenInvoicesTable = () => {
  return <InvoicesUnifiedTable variant={INVOICE_TYPE.open} />;
};

export default OpenInvoicesTable;